<script>
 import { getFormats } from './utils.js';
 import { bownload_svg } from './svgs.js';
 export let books;

 function getYear(book) {
     book.year = "";
     if (book.hasOwnProperty('pubdate') && book.pubdate.slice(0, 4) !== "0101") {
         book.year = ` (${book.pubdate.slice(0, 4)})`;
     }
     return book.year
 }
</script>

<style>
 tr:nth-child(odd) {
     background-color: #e7e7e7;
 }

 th {
     @apply text-gray-800;
     background-color: #a7a7a7;
 }

 td {
     @apply align-top px-1 pt-2 pb-1;
 }

 a:hover {
     text-decoration: underline;
     text-decoration-color: red;
     font-weight: bold;
     cursor: pointer;
 }
</style>

<table class="table-auto border-0 text-left w-full">
    <thead class="border-motw-red border-b-2">
        <tr>
            <th class="px-1 phablet:pl-2 pt-3 pb-1 w-1/4 monocle:w-1/3 phone:w-1/3">Authors</th>
            <th class="px-1 pt-3 pb-1 w-9/12">Title</th>
            <th class="text-right pr-2 w-1/12 monocle:w-1/6 phone:w-1/6">
                <img class="w-4 pt-1 inline-block" alt="dl" src="{bownload_svg}">
            </th>
        </tr>
    </thead>
    <tbody>
        {#each books as book (book._id)}
            <tr>
                <td class="phablet:pl-2 w-1/4 monocle:w-1/3 phone:w-1/3">
                    {#if book.authors}
                        <div class="monocle:text-xs phone:text-xs">
                            {#each book.authors as author, i}
                                {#if i+1 < 4 }<a title="search in authors" href="#/search/authors/{author}" class="hover:underline">{author}</a>{/if}{#if i+1 !== book.authors.length && i+i < 4 },&nbsp;{:else if i+i === 4 }&nbsp;et al.{/if}
                            {/each}
                        </div>
                    {/if}
                </td>
                <td on:click|stopPropagation="{()=> location.hash = `#/book/${book._id}`}" class="italic w-11/12 phablet:pl-2 monocle:text-xs phone:text-xs flex-grow"><a title="show book card" href="#/book/{book._id}" >{book.title}{getYear(book)}</a></td>
                <td class="pr-1 pl-2 text-right phone:text-right phablet:pl-2 flex-shrink">
                    {#each getFormats(book, "  ") as format}
                        <a href="{format.url}" title="{format.size}">{format.title}</a><br/>
                    {/each}
                </td>
            </tr>
        {/each}
    </tbody>
</table>
